import Link from 'next/link';

import styled from '@emotion/styled';

import { TileHyperLinkIcon } from '@web/ui/icons';

import { HubClasses, HubTile } from '../HubTile';

// Served from the site itself rather than the old Mux stream: Mux is a paid
// account that can lapse, and the clip is 4 MB.
const HERO_VIDEO = '/trailers/welcome-to-the-valley.mp4';

const SHubTile = styled(HubTile)`
  position: relative;
  overflow: hidden;
  background: #0a0a0a;
  color: ${({ theme }) => theme.color.light};

  .${HubClasses.topRowContainer} {
    align-items: flex-start;
  }

  /* The tile is designed full-width across three columns; stacked on a phone it
     collapses to text height and the video has no room to read as a video. */
  ${({ theme }) => theme.breakpoints.down('sm')} {
    min-height: 20rem;
  }
`;

const BackgroundVideo = styled.video`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  z-index: 0;
`;

const Scrim = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background:
    linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.6) 0%,
      rgba(0, 0, 0, 0) 32%,
      rgba(0, 0, 0, 0.25) 50%,
      rgba(0, 0, 0, 0.72) 72%,
      rgba(0, 0, 0, 0.9) 100%
    );
`;

const Spacer = styled.div`
  flex: 1 1 auto;
`;

const Content = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing('0750')};
`;

const Subtitle = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.color.light};
  font: ${({ theme }) => theme.typography.body.bold};
  font-size: ${({ theme }) => theme.typescale.size['4']};
  line-height: ${({ theme }) => theme.typescale.lineHeight.condensed};
`;

const Description = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.color.light};
  font: ${({ theme }) => theme.typography.body.regular};
  font-size: ${({ theme }) => theme.typescale.size['1']};
  line-height: ${({ theme }) => theme.typescale.lineHeight.extended};
  opacity: ${({ theme }) => theme.opacity.dense};
`;

const CTA = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing('0500')};
  margin-top: ${({ theme }) => theme.spacing('1000')};
  color: ${({ theme }) => theme.color.light};
  font: ${({ theme }) => theme.typography.mono.regular};
  font-size: ${({ theme }) => theme.typescale.size['0875']};
  line-height: ${({ theme }) => theme.typescale.lineHeight.extended};
`;

export const TrailersTile = () => (
  <Link href="/trailers">
    <SHubTile
      textColor="light"
      stateLayer="light"
      title="Trailers"
      badge={<TileHyperLinkIcon size="0750" />}
    >
      <BackgroundVideo
        src={HERO_VIDEO}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
      />
      <Scrim />
      <Spacer />
      <Content>
        <Subtitle>Animated Trailers</Subtitle>
        <Description>Three short films from Timefall Valley.</Description>
        <CTA>
          Watch trailers
          <TileHyperLinkIcon size="0750" />
        </CTA>
      </Content>
    </SHubTile>
  </Link>
);
